import { Component } from '@angular/core';
import { AccountManagerData } from '../../../../shared/models/user.model';
import { UserService } from '../../../../shared/services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import DataDogConfig from '../../../../../../config/data-dog.config';
import { ToolbarPopoverComponent } from '../toolbar-popover/toolbar-popover.component';
import { ButtonModule } from 'primeng/button';
import {CwComponentsModule} from '../../../../shared/components/components.module';

@Component({
    selector: 'zp-toolbar-contact-info',
    templateUrl: './toolbar-contact-info.component.html',
    styleUrls: ['./toolbar-contact-info.component.scss'],
    standalone: true,
    imports: [
        ButtonModule,
        ToolbarPopoverComponent,
        CwComponentsModule
    ]
})
export class ToolbarContactInfoComponent {

    public accountManagerData!: AccountManagerData;

    constructor(private userService: UserService) {
        this.userService.user$
            .pipe(takeUntilDestroyed())
            .subscribe((user) => {
                this.accountManagerData = user.accountManagerData;
            });
    }

    onAmImgError(event: Event): void {
        const target = event.target as HTMLImageElement;

        const error = new Error(`${this.accountManagerData.name} account manager, with email:${this.accountManagerData.email} has no image, default displayed`);
        DataDogConfig.captureWarning(error);

        target.src = '/assets/base/am/images/account-manager-no-image.png';
    }

}
